import styled from 'styled-components';

export const PageContainer = styled.div`
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  font-family: "AvenirNextLTW01-Regular";
  padding-bottom: 30px;
  width: 100%;
  background-image: ${(props) => `url(${props.backgroundImage})`};
  // padding-left: 15px;
  // padding-right: 15px;
`;

export const GetStartedContainer = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 265px;
  font-size: 12px;

  &.with-error{
    animation: shake 0.7s;
    animation-iteration-count: 1;
  }
`;

export const GetStartedContainerDark = styled(GetStartedContainer)`
  color: grey;
`;

export const FullPhoneNumberContainer = styled.div`
  border: 1px solid #${(props) => props.borderColor};
  box-sizing: border-box;
  border-radius: 5px 0px 0px 5px;
  display: flex;
  flex-direction: row;
  max-width: 165px;
  width: 100%;
  height: 50px;
`;

export const CountryCodeText = styled.span`
  display: flex;
  align-items: center;
  margin-right: 10px;
  margin-left: 10px;
  font-weight: bold;
  width: 30%;
  color: ${(props) => props.color}
`;

export const PhoneNumberInput = styled.input`
  background: none;
  border: 0;
  width: 70%;

  &::-webkit-outer-spin-button{
    -webkit-appearance: none;
    margin: 0;
  }
  &::-webkit-inner-spin-button{
    -webkit-appearance: none;
    margin: 0;
  }

  &[type=number]{
    -moz-appearance: textfield;
  }

  &:focus-visible {
    border: 0;
    outline: 0;
  }

  &::placeholder{
    color: ${(props) => props.placeholderColor}
  }

  &.with-error{
    color: red;
  }
`;

export const SendButton = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 17px 16px;
  border: 0;
  font-size: 12px;
  min-width: 100px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  color: ${(props) => props.foregroundColor};
  background-color: ${(props) => props.backgroundColor};
  font-family: 'Avenir';

  &:not([disabled]):hover{
    opacity: 0.8;
  }
`;

export const GetStartedButton = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 17px 16px;
  background-color: #17BFDD;
  border: 0;
  min-width: 120px;
  line-height: 16px;
  border-radius: 5px;
  font-size: 12px;
  font-family: 'Avenir';
  font-weight: bold;
  color: white;
  cursor: pointer;
`;

export const GetStartedLink = styled.a`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
padding: 17px 16px;
background-color: #17BFDD;
border: 0;
min-width: 120px;
line-height: 16px;
border-radius: 10px;
font-size: 12px;
font-family: 'Avenir';
font-weight: bold;
color: white;
cursor: pointer;

&.mobile-only{
  width: 50%;
  margin-right: auto;
  margin-left: auto;
  margin-top: 25px;
}
`;

export const StandardRates = styled.p`
text-align: right;
font-size: 12px;
padding-top: 5px;
color: rgba(0, 0, 0, 0.6);
`;
